export default (theme) => ({
  dialogContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogPaper: {
    maxWidth: 390,
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',
    display: 'inline-flex',
    flexDirection: 'column',
    padding: '30px 24px',
    gap: 40,
    position: 'relative',
    margin: 20,
    width: '100%',

    [theme.breakpoints.up(768)]: {
      maxWidth: 828,
      padding: '34px 45px',
    },

    [theme.breakpoints.up(1024)]: {
      maxWidth: 1040,
    },
  },
  dialogCloseButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    padding: 8,
  },
  dialogTitle: {
    color: '#49454F',
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
    letterSpacing: 0.5,
    paddingBottom: 8,
    borderBottom: '1px solid rgba(202, 196, 208, 0.50)',

    [theme.breakpoints.up(768)]: {
      fontSize: 24,
    },
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 24,
    width: '100%',

    [theme.breakpoints.up(768)]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  dialogDetailsPaymentItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  dialogDetailsPaymentItemLabel: {
    color: '#49454F',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '22px',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 20,
    },
  },
  dialogDetailsPaymentItemValue: {
    color: '#49454F',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '22px',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 20,
    },
  },
});
